import React from "react";
import "./App.css";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect
} from "react-router-dom";
import Header from "./Components/Header/Header";
import Footer from "./Components/Footer/Footer";
import About from "./Pages/About/About";
import Frontpage from "./Pages/Frontpage/Frontpage";
import Commissions from "./Pages/Commissions/Commissions";
import Commission from "./Pages/Commissions/Commission";
import Contact from "./Pages/Contact/Contact";
import SimpleReactLightbox from "simple-react-lightbox"; // Import Simple React Lightbox

function App() {
  return (
    <SimpleReactLightbox>
      <Router>
        <div id="app">
          <Header />
          <div id="app-inner">
            <Switch>
              <Route exact path="/commissions">
                <Commissions />
              </Route>
              <Route path="/commissions/:name">
                <Commission />
              </Route>
              <Route exact path="/about">
                <About />
              </Route>
              <Route exact path="/contact">
                <Contact />
              </Route>
              <Route exact path="/home">
                <Frontpage />
              </Route>
              <Route exact path="/" render={() => <Redirect to="/home" />} />
            </Switch>
          </div>
          <Footer />
        </div>
      </Router>
    </SimpleReactLightbox>
  );
}

export default App;
